import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useLocation, useNavigate } from 'react-router-dom';
import SBDebitNoteForm from '../components/SBDebitNoteForm';
import { Stack } from '@mui/material';
import { useCreateDebitNoteHandler } from '../../debitNotes/dataHandlers/createDebitNoteHandler';

export default function CreateSBDebitNotePage() {
  useDocumentTitle('Self Billed Debit Notes Form');
  const navigate = useNavigate();
  const location = useLocation();
  const document = location.state.document;

  const onDebitNoteCreated = (payload) => {
    if (payload.status === 'draft') {
      navigate('/self-billed-drafts?tab=self-billed-debit-notes');
    } else {
      navigate('/self-billed-documents?tab=self-billed-debit-notes');
    }
  };

  const { onSubmit, error } = useCreateDebitNoteHandler({ onSuccess: onDebitNoteCreated });

  const onSaveAsEInv = async (data) => {
    const payload = {
      ...data,
      status: 'active',
    };

    await onSubmit(payload, data.status);
  };
  const onSaveAsDraft = async (data) => {
    const payload = {
      ...data,
      status: 'draft',
    };
    await onSubmit(payload, data.status);
  };

  const onCancel = () => {
    navigate(location.state?.from || '/self-billed-documents?tab=self-billed-debit-notes');
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SBDebitNoteForm
        initialData={document || {}}
        onSubmit={onSaveAsEInv}
        onSaveDraft={onSaveAsDraft}
        onCancel={onCancel}
        apiErrors={error}
      />
    </Stack>
  );
}
